import React from 'react';
import axios from 'axios';
import { Container, Row, Col, Form, Card, Button } from 'react-bootstrap';

import './Login.css'

class ResetPassword extends React.Component{

  constructor(props){
    super(props)
    this.state = {
      password: null,
      passwordConfirmation: null,
      passwordError: '',
      verificationCode: typeof this.props.location.authProps !== "undefined" ? this.props.location.authProps.verificationCode : null,
      guid: typeof this.props.location.authProps !== "undefined" ? this.props.location.authProps.guid : null,
      mail: typeof this.props.location.authProps !== "undefined" ? this.props.location.authProps.mail : null,
    }
    this.handleOnChange = this.handleOnChange.bind(this);
    this.submitButton = this.submitButton.bind(this);
  }

  validate = () => {
    let isError = false;
    const errors = {
      passwordError: '',
      error: false
    }

    if(this.state.password !== this.state.passwordConfirmation){
      isError = true;
      errors.passwordError = 'Die Passwörter stimmen nicht überein!';
    }

    this.setState({
      ...this.state,
      ...errors
    })

    return isError;
  }

  handleOnChange(e){
    this.setState({[e.target.id]: e.target.value})
  }

  submitButton(){
    const err = this.validate()
    if(this.state.guid && this.state.verificationCode && !err){
      axios.patch(`${window._env_.REACT_APP_SERVICE_API}/auth/reset/${this.state.mail}`, { guid: this.state.guid, token: this.state.verificationCode, password: this.state.password }).then(response => {
        this.props.history.push('/')
      }).catch(error => {
        const errors = {
          passwordError: error
        }
        this.setState({
          ...this.state,
          ...errors
        })
      });
    }
  }

  render(){
    return(
      <Row className={"no-gutter"} style={{marginLeft: "-15px", marginRight: "-15px"}}>
        <div className={"d-none d-md-flex col-md-4 col-lg-4 bg-image"}></div>
        <Col md={8} lg={8}>
          <div className={"login d-flex align-items-center py-5"}>
            <Container>
              <Row>
                <Col className={"mx-auto"} md={9} lg={8} >
                 <Card.Body>
                    <Card.Text>
                      <h4>Neues Passwort</h4>
                      bitte gebe dein neues Passwort ein, und bestätige es.
                    </Card.Text>
                    <Form>
                      <Form.Group controlId="password">
                        <Form.Control 
                          type="password" 
                          value={this.state.password}
                          onChange={this.handleOnChange}
                        />
                      </Form.Group>
                      <Form.Group controlId="passwordConfirmation">
                        <Form.Control 
                          type="password" 
                          value={this.state.passwordConfirmation}
                          onChange={this.handleOnChange}
                          isInvalid={(this.state.passwordError.length > 1)}
                        />
                        <Form.Control.Feedback type="invalid">
                          {this.state.passwordError}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Button 
                        variant="primary"
                        onClick={this.submitButton} >
                        Absenden
                      </Button>
                    </Form>
                  </Card.Body>
                </Col>
              </Row>
            </Container>
          </div>
        </Col>
      </Row>
    );
  }
}

export default (ResetPassword);